<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Сертификаты"
    >
      <v-dialog v-model="dialog">
        <template #activator="{ on, attrs }">
          <v-btn
            color="red"
            dark
            class="mb-2"
            v-bind="attrs"
            v-on="on"
          >
            Генерация сертификатов
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Генерация сертификатов</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="12">
                <v-text-field
                  v-model="editedItem.count"
                  label="Количество"
                />
                <v-text-field
                  v-model="editedItem.nominal"
                  label="Номинал"
                />
                <v-text-field
                  v-model="editedItem.comment"
                  label="Комментарий"
                />
                <v-select
                  v-model="editedItem.status"
                  :items="statusList"
                  label="Статус"
                  single-line
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="close">
              Отмена
            </v-btn>
            <v-btn color="blue darken-1" text @click="save">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editDialog">
        <v-card>
          <v-card-title>
            <span class="headline">Редактирование сертификата</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="12">
                <v-text-field
                  v-model="editedItem.comment"
                  label="Комментарий"
                />
                <v-select
                  v-model="editedItem.status"
                  :items="statusList"
                  label="Статус"
                  single-line
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="closeEdit">
              Отмена
            </v-btn>
            <v-btn color="blue darken-1" text @click="save">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="data"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #body.prepend>
          <tr>
            <td></td>
            <td>
              <v-text-field
                v-model="filterNominal"
                clearable
              />
            </td>
            <td>
              <v-text-field
                v-model="filterNumber"
                clearable
              />
            </td>
            <td></td>
            <td>
              <v-select
                v-model="filterStatus"
                :items="statusList"
                clearable
              />
            </td>
            <td>
              <v-menu
                v-model="dateCreatedVis"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterCreatedAt"
                    readonly
                    v-bind="attrs"
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterCreatedAt"
                  no-title
                  locale="ru_RU"
                  @input="dateCreatedVis = false"
                ></v-date-picker>
              </v-menu>
            </td>
            <td>
              <v-menu
                v-model="dateOrderedVis"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterOrderedAt"
                    readonly
                    v-bind="attrs"
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterOrderedAt"
                  no-title
                  locale="ru_RU"
                  @input="dateOrderedVis = false"
                ></v-date-picker>
              </v-menu>
            </td>
            <td>
              <v-menu
                v-model="datePaidVis"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterPaidAt"
                    readonly
                    v-bind="attrs"
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterPaidAt"
                  no-title
                  locale="ru_RU"
                  @input="datePaidVis = false"
                ></v-date-picker>
              </v-menu>
            </td>
            <td>
              <v-menu
                v-model="dateActivatedVis"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterActivatedAt"
                    readonly
                    v-bind="attrs"
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterActivatedAt"
                  no-title
                  locale="ru_RU"
                  @input="dateActivatedVis = false"
                ></v-date-picker>
              </v-menu>
            </td>
          </tr>
        </template>
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить запись?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template #item.status="{ item }">
          {{ getStatus(item) }}
        </template>
        <template #item.createdAt="{ item }">
          {{ new Date(item.createdAt * 1000).toLocaleString("ru-RU") }}
        </template>
        <template #item.orderedAt="{ item }">
          {{ item.orderedAt ? new Date(item.orderedAt * 1000).toLocaleString("ru-RU") : '' }}
        </template>
        <template #item.payedAt="{ item }">
          {{ item.payedAt ? new Date(item.payedAt * 1000).toLocaleString("ru-RU") : '' }}
        </template>
        <template #item.activatedAt="{ item }">
          {{ item.activatedAt ? new Date(item.activatedAt * 1000).toLocaleString("ru-RU") : '' }}
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { getCertificates, createCertificate, updateCertificate, deleteCertificate } from '@/graphql/certificates'
import { startCase } from 'lodash-es'

export default {
  name: 'DiscountsList',
  components: {
  },
  layout: 'dashboard',
  apollo: {
    certificates: {
      query: getCertificates,
      variables () {
        const filter = {}
        if (this.filterNominal) {
          filter.nominal = parseFloat(this.filterNominal)
        }
        if (this.filterNumber) {
          filter.number = this.filterNumber
        }
        if (this.filterStatus) {
          filter.status = this.filterStatus
        }
        if (this.filterCreatedAt) {
          filter.createdAt = this.filterCreatedAt
        }
        if (this.filterOrderedAt) {
          filter.orderedAt = this.filterOrderedAt
        }
        if (this.filterPaidAt) {
          filter.payedAt = this.filterPaidAt
        }
        if (this.filterActivatedAt) {
          filter.activatedAt = this.filterActivatedAt
        }
        return {
          filter,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      // update: data => data.bannerArea.items.data,
      result ({ data }) {
        if (data?.certificates?.data) {
          this.data = data.certificates.data
          this.totalCount = data.certificates.totalCount
        }
      },
      update: data => data?.certificates?.data
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      dateCreatedVis: false,
      dateOrderedVis: false,
      datePaidVis: false,
      dateActivatedVis: false,
      searchNominal: '',
      totalCount: 0,
      active: [],
      open: [],
      deleteDialog: false,
      dialog: false,
      editDialog: false,
      newItem: true,
      filter: [],
      filterNominal: '',
      filterNumber: '',
      filterStatus: '',
      filterCreatedAt: '',
      filterOrderedAt: '',
      filterPaidAt: '',
      filterActivatedAt: '',
      editedItem: {},
      data: [],
      statusList: [
        { value: 'NEW', text: 'Новый' },
        { value: 'ORDERED', text: 'Куплен' },
        { value: 'PAYED', text: 'Оплачен' },
        { value: 'ACTIVATED', text: 'Активирован в заказе' },
        { value: 'DELETED', text: 'Удалён' },
        { value: 'APPLIED_IN_CART', text: 'Применён в корзине' }
      ],
      headers: [
        ['id', 'Id'],
        ['nominal', 'Номинал'],
        ['number', 'Номер'],
        ['cvv', 'Код'],
        ['status', 'Статус'],
        ['createdAt', 'Дата создания'],
        ['orderedAt', 'Дата заказа'],
        ['payedAt', 'Дата оплаты'],
        ['activatedAt', 'Дата активации'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
  },
  watch: {
    dialog (val) {
      if (!val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    },
    editDialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    getStatus (item) {
      const ret = this.statusList.filter(row => row.value === item.status)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.status
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    save () {
      if (this.newItem) {
        this.$apollo
          .mutate({
            mutation: createCertificate,
            variables: {
              input: {
                nominal: parseInt(this.editedItem.nominal),
                count: parseInt(this.editedItem.count),
                comment: this.editedItem.comment,
                status: this.editedItem.status
              }
            }
          })
          .then((data) => {
            this.$apollo.queries.certificates.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
        this.close()
      } else {
        const id = this.editedItem.id
        this.$apollo
          .mutate({
            mutation: updateCertificate,
            variables: {
              id,
              input: {
                status: this.editedItem.status,
                comment: this.editedItem.comment
              }
            }
          })
          .then((data) => {
            this.$apollo.queries.certificates.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
        this.closeEdit()
      }
      this.editedItem = []
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deleteCertificate,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.certificates.refetch()
            this.deleteDialog = null
          })
          .catch((error) => {
            console.error(error)
          })
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    close () {
      this.dialog = false
    },
    closeEdit () {
      this.editDialog = false
    },
    formatDate (timestamp) {
      const date = new Date(timestamp)
      return date.form
    }
  }
}
</script>

<style scoped>

</style>
